export const editDirectorRequest = async ({
    elem,
    form,
    dayjs,
    setEditId,
    dateFormat,
    setRecheckDocs,
    recheckDocs,
    setDocsDirector,
    setCheckIndianNationality,
    setEditAddressNull,
    setEditDirector,
    setOpen
}) => {
    setEditId(elem.id)
    setRecheckDocs(!recheckDocs)
    if (elem?.docs !== null && elem?.docs !== undefined) {
      setDocsDirector(elem?.docs)
    } else {
      setDocsDirector([])
    }
    setCheckIndianNationality(
      elem?.nationality === null ||
        elem?.nationality === "IN" ||
        elem?.nationality === "Indian"
        ? true
        : false
    )
    console.log(elem, 'elem')
    form.setFieldsValue({
      din: elem?.din,
      emailId: elem?.emailId,
      name: elem?.name,
      firstName: elem?.firstName ? elem.firstName : elem.name,
      lastName: elem?.lastName,
      phoneNumber: elem?.phoneNumber,
      nationality:
        elem?.nationality === "IN" || elem?.nationality === "Indian"
          ? "Indian"
          : elem?.nationality,
      pan: elem?.panNumber,
      addressLineOne: elem?.address?.addressLineOne,
      addressLineTwo: elem?.address?.addressLineTwo,
      city: elem?.address?.city,
      state: elem?.address?.state,
      country: elem?.address?.country,
      pinCode: elem?.address?.pinCode,
      dateOfAppointment: elem?.dateOfAppointment
        ? dayjs(elem?.dateOfAppointment, dateFormat)
        : "",
        dateOfBirth: elem?.dob ? dayjs(elem?.dob, dateFormat) : "",
        designation: elem?.designation,
    })
    if (elem?.address === null) {
      setEditAddressNull("")
    } else {
      setEditAddressNull(elem?.address?.id)
    }
    setEditDirector(true)
    setOpen(true)
  }